import React, { FunctionComponent } from 'react';
import UserConfirmation from 'libraries/wizard/components/user-confirmation';

const UseConfirmationStep: FunctionComponent = () => {
  return <UserConfirmation />;
};

export default UseConfirmationStep;
